import { Store } from 'redux';
import { createFetchRetry } from '@rsos/capstone';
import { getTokens } from '@rsos/sinatra';
import { getAPIHost } from '@rsos/utils/metaTags';

export class ALIService {
  private store: Store;

  constructor(store: Store) {
    this.store = store;
  }

  sendSecondaryLocation({
    latitude,
    longitude,
    phoneNumber,
    agencyId,
    classOfService = 'WPH1',
    secondaryCallType = 'legacyWireline',
  }: {
    latitude: number;
    longitude: number;
    phoneNumber: string;
    agencyId: string;
    classOfService?: string;
    secondaryCallType?: string;
  }) {
    const url = `${getAPIHost()}/v1/ali`;
    const now = new Date().toISOString();
    const fetchRetry = createFetchRetry(this.store);

    return fetchRetry(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${getTokens()?.token}`,
      },
      body: JSON.stringify({
        eidoVersion: '1.0',
        agencyComponent: [{ $id: agencyId }],
        agentComponent: [{ agentWorkstationPositionIdentification: '8' }],
        callComponent: [
          {
            standardPrimaryCallType: 'emergency',
            standardSecondaryCallType: secondaryCallType,
            direction: 'incoming',
            callStartTimestamp: now,
            answerDate: now,
            callStateRegistryText: 'beginCall',
          },
        ],
        callbackComponent: [
          { callBackInformationUri: [`tel:+${phoneNumber}`] },
        ],
        locationComponent: [
          {
            rsosLocationByValue: {
              singleLineAddress: {
                address: '3 Park Ave, New York, NY',
              },
              geodeticLocation: {
                latitude: latitude,
                longitude: longitude,
                uncertaintyRadius: 7.5,
              },
              classOfService: {
                classOfService: classOfService,
              },
            },
          },
        ],
      }),
    });
  }
}
